const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const toDateString = function(date) {
    var hourStr = date.getHours().toString()
    if (hourStr.length === 1) {
        hourStr = '0' + hourStr
    }

    var minuteStr = date.getMinutes().toString()
    if (minuteStr.length === 1) {
        minuteStr = '0' + minuteStr
    }

    var dayStr = date.getDate().toString()
    if (dayStr.length === 1) {
        dayStr = '0' + dayStr
    }

    var monthStr = (date.getMonth() + 1).toString()
    if (monthStr.length === 1) {
        monthStr = '0' + monthStr
    }
    return [hourStr, minuteStr].join(':') + ' ' + [dayStr, monthStr, date.getYear() + 1900].join('/');
}

const fromDateString = function(datestr) {
  var tokens = datestr.split(' ')
    
  var time = tokens[0]
  var time_tokens = time.split(':')
  var hours = time_tokens[0]
  var minutes = time_tokens[1]

  var date = tokens[1]
  var date_tokens = date.split('/')
  var day = date_tokens[0]
  var month = date_tokens[1]
  var year = date_tokens[2]

  var d = new Date()
  d.setHours(hours)
  d.setMinutes(minutes)
  
  d.setYear(year)
  d.setMonth(month-1)
  d.setDate(day)

  return d
}

const osloLatLng = { lat: 59.9139, lng: 10.7522 }

export { byPropKey, fromDateString, toDateString, osloLatLng };


// WEBPACK FOOTER //
// ./src/components/utils.js